<template>
  <div>
    <collapse :title="$t('navigation.categories')">
      <b-table
        :data="categories"
        :striped="true"
        :mobile-cards="false"
        :narrowed="true"
        :loading="loading"
        :default-sort="['type', 'desc']"
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$t('category.name')" sortable>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="type" :label="$t('category.type')" sortable>
            {{ props.row.type }}
          </b-table-column>
          <b-table-column>
            <b-button class="button is-primary" @click="editCategory(props.row)"
              ><b-icon icon="edit" size="is-small"></b-icon
            ></b-button>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="frown" size="is-large"> </b-icon>
              </p>
              <p>
                {{ $t("table.noCategories") }}
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </collapse>
    <category-modal
      :isCategoryModalActive="isCategoryModalActive"
      :categoryToEdit="selectedCategory"
      @close="isCategoryModalActive = false"
    ></category-modal>
  </div>
</template>

<script>
import Collapse from "@/components/Collapse.vue";
const CategoryModal = () => import("@/components/modals/CategoryModal.vue");

export default {
  name: "categoriesTable",
  components: {
    Collapse,
    CategoryModal
  },
  data() {
    return {
      isCategoryModalActive: false,
      selectedCategory: {}
    };
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    editCategory(category) {
      this.selectedCategory = category;
      this.isCategoryModalActive = true;
    }
  }
};
</script>
